module.exports = __webpack_public_path__ + "img/standard.05a4569d.svg";